import React from "react"
import styled from "styled-components"

export const Container = styled.div`
  position: relative;
  overflow: hidden;
`

const Padding = styled.div`
  width: 100%;
  padding-bottom: 100%;
`

const Image = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.3);
`

export interface ImageHelperProps {
  alt?: string
  className?: string
  imageProps?: any
  maxWidth?: string
  overlay?: boolean
  quality?: number
  src: string
}

const widths = [
  "320w",
  "600w",
  "800w",
  "1024w",
  "1200w",
  "1440w",
  "1920w",
  "2560",
]

const ImageHelper: React.FC<ImageHelperProps> = ({
  alt,
  className,
  imageProps,
  maxWidth,
  overlay,
  quality = 70,
  src,
}: ImageHelperProps) => {
  const srcWidths = maxWidth
    ? [...widths, `${parseFloat(maxWidth)}w`].filter(
        (w) => parseFloat(w) < parseFloat(maxWidth)
      )
    : widths
  const webpSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality}&fm=webp ${w}`
  )
  const pngSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality}&fm=webp ${w}`
  )
  const fallbackSources = srcWidths.map(
    (w) => `${src}?w=${parseFloat(w)}&q=${quality} ${w}`
  )

  return (
    <Container className={className}>
      <Padding />
      <picture>
        <source srcSet={webpSources.join(", ")} type="image/webp" />
        <source srcSet={pngSources.join(", ")} />
        <Image
          alt={alt || ""}
          srcSet={fallbackSources.join(", ")}
          {...imageProps}
        />
      </picture>
      {overlay && <Overlay />}
    </Container>
  )
}

export default ImageHelper
